<main class="co-content clearfix row">
  <app-login-alert *ngIf="!isLoggedIn && !isConfirmation"></app-login-alert>
  <section class="co-content__left columns small-12 medium-7">
    <router-outlet></router-outlet>
  </section>
  <aside class="co-content__right co-sidebar columns small-12 medium-5">
    <app-summary *ngIf="!isConfirmation"></app-summary>
  </aside>
</main>
